import { columnsOf, toCsvLine } from './csv.helpers.ts';
import type { TCsvOptions, TCsvRow } from './csv.types.ts';

const LINE_BREAK = '\r\n';
const BYTE_ORDER_MARK = '\uFEFF';

export const convertToCsv = <TRow extends TCsvRow>(
  rows: TRow[],
  {
    columns = columnsOf(rows),
    headers = {},
    delimiter = ',',
    escapeFormulas = true,
    byteOrderMark = false,
  }: TCsvOptions<TRow> = {},
): string => {
  if (columns.length === 0) {
    return '';
  }

  const prefix = byteOrderMark ? BYTE_ORDER_MARK : '';

  const headerLine = toCsvLine(
    columns.map((column) => headers[column] ?? column),
    delimiter,
    escapeFormulas,
  );

  const lines = rows.map((row) =>
    toCsvLine(
      columns.map((column) => row[column]),
      delimiter,
      escapeFormulas,
    ),
  );

  return prefix + [headerLine, ...lines].join(LINE_BREAK);
};
